import React from "react";
import { Link } from "react-router-dom";

const Button = ({ children, to, href, variant = "gold", className = "", ...rest }) => {
  const base =
    "inline-block px-7 py-3 uppercase text-[11px] tracking-[0.25em] font-semibold font-cinzel transition-all";
  const variants = {
    gold: "bg-gradient-to-b from-[#B79A68] to-[#8D7448] hover:from-[#C8AE7F] hover:to-[#A18354] text-[#ffffff]",
    outline:
      "border border-[#B79A68] text-[#7D6A42] hover:bg-[#B79A68] hover:text-[#ffffff]",
    dark: "bg-[#ffffff] hover:bg-[#FBF8F1] text-[#20322E] border border-[#B79A68]/40",
  };
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...rest}>{children}</Link>;
  return <a href={href} className={cls} {...rest}>{children}</a>;
};

export default Button;
